import "./PatientTableHeader.css";
import DoubleArrowIcon from "../../../../components/icons/DoubleArrowIcon";
import DownArrowIcon from "../../../../components/icons/DownArrowIcon";
import UpArrowIcon from "../../../../components/icons/UpArrowIcon";
import useTranslation from "../../../../hooks/i18n/useTranslation";

function PatientTableHeader({ sortColumn, sortDirection, handleSort }) {
  const { t } = useTranslation();

  const columns = [
    { tradId: "6", property: "first_name" },
    { tradId: "7", property: "last_name" },
    { tradId: "8", property: "birthday" },
    { tradId: "9", property: "gender" },
    { tradId: "18", property: "last_access" },
  ];

  return (
    <div className="App-patient-table-header">
      <table className="App-patient-header-table">
        <colgroup>
          <col style={{ width: "var(--col-1)" }} />
          <col style={{ width: "var(--col-2)" }} />
          <col style={{ width: "var(--col-3)" }} />
          <col style={{ width: "var(--col-4)" }} />
          <col style={{ width: "var(--col-5)" }} />
          <col style={{ width: "var(--col-actions)" }} />
        </colgroup>
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th
                key={index}
                onClick={() => handleSort(col.property)}
                className="App-patient-orderable-header"
              >
                <div className="App-patient-orderable-head App-normal-text">
                  <span>{t(col.tradId)}</span>
                  <div className="App-patient-arrow-icon">
                    {col.property === sortColumn ? (
                      sortDirection === "asc" ? (
                        <UpArrowIcon />
                      ) : (
                        <DownArrowIcon />
                      )
                    ) : (
                      <DoubleArrowIcon />
                    )}
                  </div>
                </div>
              </th>
            ))}
          </tr>
        </thead>
      </table>
    </div>
  );
}

export default PatientTableHeader;
